import httpClient from '../utils/httpClient';

export const findDocument = async filter => {
	const { data, error } = await httpClient({
		method: 'get',
		url: `/documents/${filter.code}`
	});

	return { data, error };
};

export const findDocumentProtected = async documentData => {
	const { data, error } = await httpClient({
		method: 'get',
		url: `/documents/${documentData.code}/protected`,
		params: documentData
	});

	return { data, error };
};

export const signature = async documentData => {
	const formData = new FormData();

	formData.append('file', documentData.file);

	formData.append('code', documentData.code);

	if (documentData.document_number) {
		formData.append('document_number', documentData.document_number);
	}

	const { data, error, status } = await httpClient({
		method: 'post',
		url: `/documents/${documentData.id}/signature`,
		data: formData
	});

	if (!error && status !== 'success') {
		return { data, error: { code: 'SIGNATURE_NOT_CONFIRMED' } };
	}

	return { data, error };
};

export const exportPdf = async ({ code, id }) => {
	const { data, error } = await httpClient({
		method: 'post',
		url: `/documents/${id}/pdf`,
		data: { code }
	});

	return { data, error };
};
